import type {ReactElement} from 'react';
import {useRef} from 'react';
import React from 'react';
import type {BaseContextualMenuGridItemProps} from './base-contextual-menu-grid-item.types';
import styles from './base-contextual-menu-grid-item.module.scss';
import {useInViewport} from 'ahooks';
import {ContextualMenuThumbnailItem} from '@Components/contextual-menu/components/contextual-menu-thumbnail-item';
import {AnimatePresence, motion} from 'framer-motion';

export function BaseContextualMenuGridItem({
  shouldShowSubOptionsNext = false,
  isLoading = false,
  isSelected = false,
  hasCustomDimensions = false,
  hasBorder = true,
  containerClass = '',
  ...props
}: BaseContextualMenuGridItemProps): ReactElement<any> {
  const thumbRef = useRef<HTMLDivElement | null>(null);
  const isInViewPort = useInViewport(thumbRef);

  const getThumbnailItem = (): ReactElement<any> => {
    return (
      <ContextualMenuThumbnailItem
        id={props.id}
        key={props.id}
        isDisabled={isLoading}
        hasCustomMargin
        hasCustomDimensions={hasCustomDimensions}
        thumbnailContainerClassName={`radius-12 ${styles.thumbnailContainer}`}
        hasBorder={hasBorder}
        isSelected={isSelected}
        text={props.text}
        textClassName={'content-sub-text'}
        thumbnail={props.thumb}
        onClick={props.onSelected}
      />
    );
  };

  const getItem = (): ReactElement<any> => {
    return (
      <div className={`${styles.container} ${containerClass ? containerClass : `spacing-m-b-5 ${styles.itemContainer}`}`} ref={thumbRef}>
        {isInViewPort[0] ? React.cloneElement(getThumbnailItem(), {}) : null}
      </div>
    );
  };

  const getBaseContextualMenuGridItem = (): ReactElement<any> => {
    if (props.hasSubOptions) {
      return (
        <>
          {getItem()}
          <AnimatePresence initial={false}>
            {props.subOptionToShow && shouldShowSubOptionsNext ? (
              <motion.div
                layout
                initial={{height: 0}}
                animate={{height: 'auto'}}
                transition={{duration: 0.2}}
                exit={{height: 0}}
                className={`_full-width ${styles.animationContainer}`}
              >
                {props.subOptionToShow}
              </motion.div>
            ) : null}
          </AnimatePresence>
        </>
      );
    }
    return getItem();
  };

  return getBaseContextualMenuGridItem();
}
